const getPlatform = () => {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) return "Android";
  if (/iPad|iPhone|iPod/.test(ua)) return "iOS";
  if (/Win/.test(ua)) return "Windows";
  if (/Mac/.test(ua)) return "macOS";
  if (/Linux/.test(ua)) return "Linux";
  return "Unknown";
};

const getBrowser = () => {
  const ua = navigator.userAgent;
  if (/chrome|chromium|crios/i.test(ua)) return "Chrome";
  if (/firefox|fxios/i.test(ua)) return "Firefox";
  if (/safari/i.test(ua) && !/chrome/i.test(ua)) return "Safari";
  if (/edg/i.test(ua)) return "Edge";
  return "Unknown";
};

export const getBrowserInfo = () => {
  const { userAgent, language } = window.navigator;
  const { width, height, colorDepth } = window.screen;

  const platform = getPlatform();
  const browser = getBrowser();

  const features = {
    cookies: navigator.cookieEnabled,
    javaScript: true,
    online: navigator.onLine,
    doNotTrack: navigator.doNotTrack || "unspecified",
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    languages: navigator.languages,
    hardwareConcurrency: navigator.hardwareConcurrency,
  };

  return {
    userAgent,
    platform,
    browser,
    language,
    url: window.location.href,
    screen: { width, height, colorDepth },
    features,
    timestamp: new Date().toISOString(),
  };
};
